import {
    createBrowserRouter,
} from "react-router-dom";
import AppPage from "../AppPage";
import RoutePaths from "./RoutePaths";
import NetworkExamplePage from "../examples/network/NetworkExamplePage";
import ChartsExamplePage from "../examples/charts/ChartsExamplePage";
import StateExamplePage from "../examples/state/StateExamplePage";
import SearchPage from "../pages/SearchPage";
import NewsQueue from "../newsQueue";
import Monitoring from "../monitoring";
import MonitoringAllSources from "../monitoring/AllSourcesDetail";
import MonitoringAlerts from "../monitoring/AlertsDetail";
import MonitoringMedia from "../monitoring/MediaDetail";
import MonitoringSource from "../monitoring/SourceDetail";
import MonitoringRun from "../monitoring/RunDetail";
// @TEMPLATE: Import the necessary components and themes here.
import MediaSelectionPage from '../pages/MediaSelectionPage';
import ShorthandPage from '../pages/ShorthandPage';
import DeskPage from '../pages/DeskPage';

// @TEMPLATE: Define the router path components here.
const Router = createBrowserRouter([
    {
        path: RoutePaths.newsQueue.root,
        element: <NewsQueue />,
        children: [{ path: RoutePaths.newsQueue.article, element: null }],
    },
    {
        path: RoutePaths.newsQueue.mediaSelection,
        element: <MediaSelectionPage />,
    },
    {
        path: RoutePaths.newsQueue.shorthand,
        element: <ShorthandPage />,
        children: [{ path: RoutePaths.newsQueue.article, element: null }],
    },
    {
        path: RoutePaths.newsQueue.desk,
        element: <DeskPage />,
        children: [{ path: RoutePaths.newsQueue.article, element: null }],
    },
    {
        path: RoutePaths.newsQueue.media,
        element: <DeskPage />,
        children: [{ path: RoutePaths.newsQueue.article, element: null }],
    },
    {
        path: RoutePaths.monitoring.root,
        element: <Monitoring />,
    },
    {
        path: RoutePaths.monitoring.allSources,
        element: <MonitoringAllSources />,
    },
    {
        path: RoutePaths.monitoring.alerts,
        element: <MonitoringAlerts />,
    },
    {
        path: RoutePaths.monitoring.run,
        element: <MonitoringRun />,
    },
    {
        path: RoutePaths.monitoring.source,
        element: <MonitoringSource />,
    },
    {
        path: RoutePaths.monitoring.media,
        element: <MonitoringMedia />,
    },
    {
        path: RoutePaths.root.root,
        element: <SearchPage />,
        children: [
            {
                index: true, // root
                element: <SearchPage />,
            },
            {
                path: `${RoutePaths.root.search}/:search_id`,
                element: <SearchPage />,
            },
        ],
    },
]);

export default Router;